<template>
  <div>
    <el-dialog
      :title="$t('lang.二级密码')"
      :visible.sync="dialogVisible"
      :before-close="onClickCancel"
    >
      <el-form
        :label-width="$i18n.locale == 'zh-CN' ? '130px' : '170px'"
        ref="ruleFormRef"
        :rules="rules"
        :model="passwordForm"
      >
        <div>
          <el-form-item
            :label="$t('lang.旧密码')"
            prop="password"
            v-if="isSetPwd"
          >
            <el-input
              type="password"
              :placeholder="$t('lang.请输入旧密码')"
              v-model="passwordForm.password"
              show-password
              oninput="value=value.replace(/[^\d]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="isSetPwd ? $t('lang.新密码') : $t('lang.二级密码')"
            prop="newPassword"
          >
            <el-input
              type="password"
              :placeholder="
                isSetPwd ? $t('lang.请输入新密码') : $t('lang.请输入二级密码')
              "
              v-model="passwordForm.newPassword"
              show-password
              oninput="value=value.replace(/[^\d]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.确认密码')" prop="confirmPassword">
            <el-input
              type="password"
              :placeholder="
                isSetPwd
                  ? $t('lang.请再次输入新密码')
                  : $t('lang.请再次输入二级密码')
              "
              v-model="passwordForm.confirmPassword"
              show-password
              oninput="value=value.replace(/[^\d]/g,'')"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClickCancel">{{ $t("lang.取消") }}</el-button>
        <el-button type="primary" @click="onClickSubmit">{{
          $t("lang.确定")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    var password = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lang.请输入")));
      } else {
        callback();
      }
    };
    var newPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lang.请输入")));
      } else {
        callback();
      }
    };
    var confirmPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lang.请输入")));
      } else if (this.passwordForm.newPassword != value) {
        callback(new Error(this.$t("lang.两次密码输入不一致")));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      isSetPwd: false,
      passwordForm: {
        password: "",
        newPassword: "",
        confirmPassword: "",
      },
      rules: {
        password: [{ validator: password, trigger: "blur" }],
        newPassword: [{ validator: newPassword, trigger: "blur" }],
        confirmPassword: [{ validator: confirmPassword, trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapActions({
      passwordUpdate: "ZD_SecurityPasswordUpdate",
    }),
    show(isSet) {
      this.isSetPwd = isSet;
      this.dialogVisible = true;
    },
    async onClickSubmit() {
      try {
        await this.$refs.ruleFormRef.validate();
        let tempReq = {
          password: this.passwordForm.newPassword,
        };
        if (this.isSetPwd) {
          tempReq.oldPassword = this.passwordForm.password;
        }
        let res = await this.passwordUpdate(tempReq);
        if (res.success !== 1) return;
        this.$message({
          message: this.$t("lang.修改成功"),
          type: "success",
        });
        this.onClickCancel();
        this.$emit("onRefresh");
      } catch {}
    },
    onClickCancel() {
      this.dialogVisible = false;
      this.$refs.ruleFormRef.resetFields();
    },
  },
};
</script>

<style scoped lang='less'>
/deep/ .el-dialog {
  width: 576px;
}
/deep/ .el-dialog .el-input {
  width: 300px;
}
/deep/.el-dialog__body {
  padding-bottom: 10px;
  padding-left: 40px;
}
</style>